module.exports = __webpack_public_path__ + "static/media/DSC_6903.0052ca00.jpg";